import './Skeleton.css';

export function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-bar" style={{ width: '75%', height: 12 }} />
      <div className="skeleton-bar" style={{ width: '45%', height: 8, animationDelay: '0.2s' }} />
    </div>
  );
}

export function SkeletonRow() {
  return (
    <div className="skeleton-row">
      <div className="skeleton-bar" style={{ width: '70%', height: 12 }} />
      <div className="skeleton-bar" style={{ width: '40%', height: 8, animationDelay: '0.3s' }} />
    </div>
  );
}
